import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import Fees from './Fees'
import CertificationUpload from './CertificationUpload'
import FeeBreakdown from './FeeBreakdown'
import { fileUpload, fileDelete } from '../../api/uploadApi'

const FeeAndCertForm = ({
  value = {},
  onChange,
  readOnly = false,
  fieldError,
  fieldErrors,
  fieldType
}) => {
  const { fees = {}, certification = {}, feeBreakdown = [] } = value
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState('')

  // Fees section
  const handleFeesChange = (newFees) => {
    onChange && onChange({ ...value, fees: newFees })
  }

  // Certification section
  const handleCertificationChange = (certObj) => {
    onChange && onChange({ ...value, certification: certObj })
  }

  // Actual async file upload
  const handleFileChange = async (file) => {
    setError('')
    setUploading(true)
    try {
      const data = await fileUpload(file)  // You can pass a progress callback if your uploadFile supports it
      handleCertificationChange({
        fileUrl: data.url,
        fileName: file.name
      })
    } catch (e) {
      setError('File upload failed!')
    }
    setUploading(false)
  }

  // Actual file delete (optional, if you want to delete from server too)
  const handleRemove = async () => {
    setError('')
    if (certification.fileUrl) {
      try {
        await fileDelete(certification.fileUrl)
      } catch (e) {
        setError('Failed to delete file!')
        // Still remove from UI
      }
    }
    handleCertificationChange({ fileUrl: '', fileName: '' })
  }

  // Fee breakdown section
  const handleFeeBreakdownChange = (newBreakdown) => {
    onChange && onChange({ ...value, feeBreakdown: newBreakdown })
  }

  return (
    <>
      <Typography sx={{ fontWeight: 600, mb: 1 }}>Fees</Typography>
      <Fees
        value={fees}
        onChange={handleFeesChange}
        readOnly={readOnly}
        fieldErrors={fieldErrors}
        fieldError={fieldError}
        fieldType={fieldType}
      />

      <Box mt={4}>
        <CertificationUpload
          fileUrl={certification.fileUrl}
          fileName={certification.fileName}
          onUpload={handleFileChange}
          onDelete={handleRemove}
          readOnly={readOnly}
          uploading={uploading}
          // progress={progress}
          error={error}
          fieldErrors={fieldErrors}
          fieldError={fieldError}
          fieldType={fieldType}
        />
      </Box>
      {/* 
      <FeeBreakdown
        value={feeBreakdown}
        onChange={handleFeeBreakdownChange}
        readOnly={readOnly}
      /> */}
    </>
  )
}

export default FeeAndCertForm
